/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
import * as moment from 'moment';
import {Moment} from 'moment';

export class AnalyticsEvent {

    private _name: string;
    private _group: string;
    private _date: Moment;
    private _properties: any;

    constructor(obj?: any) {
        if (obj !== undefined && obj !== null) {
            Object.assign(this, obj);
            this._date = moment(obj._date);
        }
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get group(): string {
        return this._group;
    }

    set group(value: string) {
        this._group = value;
    }

    get date(): moment.Moment {
        return this._date;
    }

    set date(value: moment.Moment) {
        this._date = value;
    }

    get properties(): any {
        return this._properties;
    }

    set properties(value: any) {
        this._properties = value;
    }

    toRequest() {
        return {
            name: this.name,
            group: this.group,
            properties: this.properties,
            date: this.date.format('YYYY-MM-DD HH:mm:ss'),
        };
    }

}
